import type { CharityDetails } from '@/api/charitiesAPI'
import type { PageEntry } from './hooks/useBatchScrape'

export type EntityType = 'charity' | 'other'

export interface OrgFormData {
  orgName: string
  website: string
  description: string
  regionIds: number[]
  iwi: number[]
  showIwiInput: boolean
  refuseGambling: boolean
  acceptInternational: boolean
}

export interface DiscoveredPage {
  url: string
  title?: string
}

export interface DescriptionParts {
  partOne: string
  partTwo: string
  partThree: string
  partFour: string
  partFive: string
}

export interface WriteModeDraft {
  title: string
  description: string
  descriptionParts: DescriptionParts
  min_amount: string
  amount: string
  regionIds: number[]
  uses_org_regions?: boolean
  fundingIdeasSessionId?: number
}

export interface GuidedFlowSnapshot {
  suggestions: Array<{ title: string }>
  selectedSuggestion: { title: string } | null
  interestReason: string
  sessionId: number | null
}

export interface WizardData {
  // Pre-org-creation (no server home until org created)
  entityType: EntityType | null
  charityDetails: CharityDetails | null
  orgNumber: string

  // Step 5 — org details form
  orgForm: OrgFormData | null

  // Step 7 — page list (single source of truth)
  pages: PageEntry[]
  discoveredPages: DiscoveredPage[]
  discoveredForWebsite: string

  // Funding flow
  fundingMode: 'write' | 'guided' | null
  additionalContext: string

  // Write-mode funding draft (survive navigation)
  writeModeDraft: WriteModeDraft | null

  // Guided flow snapshot — persists conversation state across remounts
  guidedFlowSnapshot: GuidedFlowSnapshot | null

  // Scan completion flag (set when SSE reports done, guards skip on re-entry)
  scanCompleted: boolean

  // Subscribe prompt: true after user dismisses the auto-open subscribe dialog
  subscribePromptDismissed: boolean

  // Set when a scan returned ≥3 selectable matches — prevents re-scanning after success
  scanHadResults: boolean
}

export const INITIAL_WIZARD_DATA: WizardData = {
  entityType: null,
  charityDetails: null,
  orgNumber: '',
  orgForm: null,
  pages: [],
  discoveredPages: [],
  discoveredForWebsite: '',
  fundingMode: null,
  additionalContext: '',
  writeModeDraft: null,
  guidedFlowSnapshot: null,
  scanCompleted: false,
  subscribePromptDismissed: false,
  scanHadResults: false,
}
